<template>
	<header
		v-if="!global.isSessionExpired()"
		class="px-2 sticky top-0 z-40 bg-white text-black nav_sesion"
	>
		<nav class="bg-white shadow-lg">
			<div class="max-w-6xl mx-auto px-4 text-md">
				<div class="flex justify-between">
					<div class="flex space-x-7">
							<!-- Website Logo -->
							<a href="#" class="flex items-center py-4 px-2">
								<router-link
									to="/"
									class="cursor-pointer"
									:class="`hover:text-${colors.primary}-600`"
								>
									<div class="grid grid-cols-2 gap-x-5">
										<div>
											<img
												alt="logo"
												src="../../assets/TRECUPERA_new_transparent.png"
												class="w-24 md:w-40"
											/>
										</div>
										<div
											v-if="
												global.getRolSession() ===
												'CLIENT'
											"
										>
											<img
												v-if="logoTenant !== ''"
												alt="logo"
												:src="logoTenant"
												class="w-24 md:w-40"
											/>
										</div>
									</div>
								</router-link>
							</a>
						<!-- Primary Navbar items -->
						<div class="hidden md:flex items-center space-x-1">
							<a
								v-if="global.getRolSession() === 'CLIENT'"
								to="/client-area"
								class="cursor-pointer font-semibold transition duration-300"
								:class="`hover:text-${colors.primary}-600`"
								>Área de cliente</a
							>
							<a
								v-if="global.getRolSession() === 'ADMIN'"
								to="/admin"
								class="cursor-pointer font-semibold transition duration-300"
								:class="`hover:text-${colors.primary}-600`"
								>Zona de administración</a
							>
						</div>
					</div>
					<!-- Secondary Navbar items -->
					<div class="md:flex items-center space-x-3">
						<a
							v-if="
								global.getRolSession() === 'CLIENT' &&
								global.getConfirmDate() !== null &&
								global.getUserPlanSession() !== null
							"
							class="py-2 px-2 font-medium text-black capitalize cursor-pointer"
							><notifications-count
								@onFire="eventOpenModal_notification()"
								:openModal="data_.openModalNotification"
						/></a>

						<!-- button
							@click="openUserDropDown()"
							id="dropdownNavbarLink"
							data-dropdown-toggle="dropdownNavbar"
							class="flex justify-between items-center py-2 pr-4 pl-3 w-full font-medium text-black border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:p-0 md:w-auto dark:hover:text-white dark:focus:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"
							:class="`md:hover:text-${colors.primary}-600`"
					    -->

						<button
							@click="openUserDropDown()"
							id="dropdownNavbarLink"
							data-dropdown-toggle="dropdownNavbar"
							class="hidden md:flex justify-between items-center py-2 pr-4 pl-3 w-full font-medium text-black border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:p-0 md:w-auto"
							:class="`md:hover:text-${colors.primary}-600`"
						>
							{{ global.getUserNameSession() }}
							<fa
								v-if="data_.openUserDrop"
								class="mx-1 w-4 h-4"
								icon="angle-up"
							/>
							<fa v-else class="mx-1 w-4 h-4" icon="angle-down" />
							<avatar-name :name="global.getUserNameSession()" />
						</button>
						<!-- Dropdown menu -->
						<!--div
							v-if="data_.openUserDrop"
							v-on:mouseleave="openUserDropDown()"
							v-on:mouseUpCapture="openUserDropDown()"
							id="dropdownNavbar"
							class="absolute mt-40 z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
						-->
						<div
							v-if="data_.openUserDrop"
							v-on:mouseleave="openUserDropDown()"
							v-on:mouseUpCapture="openUserDropDown()"
							id="dropdownNavbar"
							class="absolute mt-40 z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow"
						>
							<div class="mt-3 h-20">
								<a
									v-if="
										global.getRolSession() === 'CLIENT' &&
										global.getConfirmDate() !== null &&
										global.getUserPlanSession() !== null
									"
									@click="goRoute_()"
									class="cursor-pointer block py-2 px-4 text-black hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
									>Ver Plan</a
								>
								<a
									@click="eventOpenModal_logout()"
									class="cursor-pointer block py-2 px-4 text-black hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
									>Salir</a
								>
							</div>
						</div>
					</div>
					<!-- Mobile menu button -->
					<div class="md:hidden flex items-center">
						<button class="outline-none mobile-menu-button navbar-toggler"
						type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
							<svg
								class="w-6 h-6 text-black navbar-toggler-icon"
								:class="`hover:text-${colors.primary}-600`"
								x-show="!showMenu"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path d="M4 6h16M4 12h16M4 18h16"></path>
							</svg>
						</button>	
					</div>
				</div>
			</div>
			<!-- mobile menu -->
			<div class="md:hidden mobile-menu collapse navbar-collapse" id="navbarText">
						<div
							href="/admin"
							class="block text-md px-2 py-4 transition duration-300"
							>{{ global.getUserNameSession() }}
							<avatar-name :name="global.getUserNameSession()" /></div
						>
		
						<a
							v-if="global.getRolSession() === 'CLIENT'"
							href="/client-area"
							class="block text-md px-2 py-4 transition duration-300"
							:class="`hover:bg-${colors.primary}-600`"
							>Área de cliente</a
						>
						<a
							v-if="global.getRolSession() === 'ADMIN'"
							href="/admin"
							class="block text-md px-2 py-4 transition duration-300"
							:class="`hover:bg-${colors.primary}-600`"
							>Zona de administración</a
						>
						<a
							v-if="
								global.getRolSession() === 'CLIENT' &&
								global.getConfirmDate() !== null &&
								global.getUserPlanSession() !== null
							"
							href="/client-area/profile"
							class="block text-md px-2 py-4 transition duration-300"
							:class="`hover:bg-${colors.primary}-600`"
							>Ver Plan</a
						>
						<a
							v-if="
								global.getRolSession() === 'CLIENT' &&
								global.getConfirmDate() !== null &&
								global.getUserPlanSession() !== null
							"
							href="/admin"
							class="block text-md px-2 py-4 transition duration-300"
							:class="`hover:bg-${colors.primary}-600`"
							>Salir</a
						>
				
			</div>
		</nav>
	</header>
	<notification-modal
		v-if="data_.openModalNotification"
		@onFire="eventOpenModal_notification"
		:openModal="data_.openModalNotification"
	/>
	<logout-modal
		v-if="data_.openModalLogout"
		:openModal="data_.openModalLogout"
		@onFire="eventOpenModal_logout"
		@onFireLogout="logout_"
	/>
</template>

<script>
	import * as global from "../../api/global";
	import { useRoute, useRouter } from "vue-router";
	import { reactive } from "vue";
	import AvatarName from "@/components/Commons/AvatarName.vue";
	import NotificationModal from "@/components/Msj/NotificacionModal.vue";
	import NotificationsCount from "@/components/Msj/NotificationsCount.vue";
	import LogoutModal from "@/components/Commons/LogoutModal.vue";

	export default {
		name: "NavBarTRecuperaSession",
		components: {
			AvatarName,
			NotificationModal,
			NotificationsCount,
			LogoutModal,
		},
		//props: ["type"],

		setup() {
			const state = global.state;
			const { colors } = state.configTenant.template;
			const { logo2, tenantId } = state.configTenant;
			const logoTenant =
				logo2 !== "" && global.getTenantDomain() !== "wivai"
					? require("../../assets/siteImages/" + tenantId + "/" + logo2)
					: "";

			const router = useRouter();

			const goRoute_ = () => {
				router.push("/client-area/profile");
			};

			const openUserDropDown = () => {
				data_.openUserDrop = !data_.openUserDrop;
			};

			const route = useRoute();
			const currentPath = route.fullPath;

			const data_ = reactive({
				openModalNotification: false,
				openUserDrop: false,
				openModalLogout: false,
				route: useRoute(),
			});

			const eventOpenModal_notification = () => {
				data_.openModalNotification = !data_.openModalNotification;
			};

			const eventOpenModal_logout = () => {
				data_.openModalLogout = !data_.openModalLogout;
			};

			const logout_ = () => {
				global.logout(true);
			};

			return {
				currentPath,
				data_,
				eventOpenModal_notification,
				eventOpenModal_logout,
				openUserDropDown,
				goRoute_,
				logout_,
				colors,
				global,
				logoTenant,
			};
		},
	};
</script>

<style>
	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: white;
	}

	#nav a.router-link-exact-active {
		color: #bababb;
	}

	.nav_sesion a {
		color: rgb(0, 0, 0) !important;
	}

	.nav_sesion a.router-link-exact-active {
		color: #bababb !important;
	}

	.nav_sesion_other a {
		color: white !important;
	}

	.nav_sesion_other {
		color: white !important;
	}

	.collapse.navbar-collapse {
		display: none;
	}

	.collapse.navbar-collapse.show {
		display: block;
		visibility: visible !important;
	}
	
</style>
